import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import debounce from 'lodash.debounce';
import { lerp, map } from '../utils.js';

export default class HomeHero {
	constructor(elm) {
        this.elm = elm;

        this.textLines = this.elm.querySelectorAll('[data-home-hero-text]');
        this.circle = this.elm.querySelector('[data-home-hero-circle]');
        this.gradientWrapper = this.circle.querySelector('[data-home-hero-circle-gradient-wrapper]');
        this.gradient = this.circle.querySelector('[data-home-hero-circle-gradient]');

        // this.animatedIn = false;

        this.boundHandleMousemove = debounce(this.handleMousemove.bind(this), 10);
		window.addEventListener('mousemove', this.boundHandleMousemove);

        this.currentEvent = null;

        this.translationVals = {
			tx: 0,
			ty: -50,
			scale: 1
		};

        this.xstart = 50;
		this.ystart = 50;
		this.scaleStart = 7;

        this.calculateMouse = () => {
            if(!this.currentEvent) {
                return;
            }

            this.translationVals.tx = lerp(this.translationVals.tx, map(this.currentEvent.clientX, 0, window.innerWidth*1, -this.xstart*1, this.xstart*1), 0.02).toFixed(2);
			this.translationVals.ty = lerp(this.translationVals.ty, map(this.currentEvent.clientY, 0, window.innerHeight, -this.ystart, this.ystart), 0.02).toFixed(2);
            this.translationVals.scale = lerp(this.translationVals.scale, map(this.currentEvent.clientY, 0, window.innerHeight, this.scaleStart / 10, 0.9), 0.05);

            gsap.set(this.gradient, {
                translateY: (((this.translationVals.ty/130)*100)*0.95) + '%',
                translateX: (((this.translationVals.tx/130)*100)*0.95) + '%',
            });

            gsap.set(this.circle, {
				translateX: this.translationVals.tx,
				translateY: this.translationVals.ty,
                scale: 0.7 + (1 - this.translationVals.scale),
			});
        }

        ScrollTrigger.create({
            trigger: this.elm,
            start: "top bottom",
            end: "bottom top",
            onToggle: self => {
                if(self.isActive) {
                    this.addTicker();
                } else {
                    this.removeTicker();
                }
            },
        });

	}

    addTicker() {
        let mm = gsap.matchMedia();

        mm.add({
            isDesktop: `(min-width: 576px)`,
            isMobile: `(max-width: 575px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)",
            hasHover: "(hover: hover) and (pointer: fine)"
          }, (context) => {

            let { isDesktop, isMobile, reduceMotion, hasHover } = context.conditions;

            if(isDesktop&&hasHover) {
                gsap.ticker.add(this.calculateMouse);
            }

            this.init();

        });
    }

    removeTicker() {
        gsap.ticker.remove(this.calculateMouse);
    }

    handleMousemove(e) {
        this.currentEvent = e;
    }

	init() {
        if(this.animatedIn) {
            return;
        }
        this.animatedIn = true;


        let mm = gsap.matchMedia();

        mm.add({
            isDesktop: `(min-width: 576px)`,
            isMobile: `(max-width: 575px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)"
          }, (context) => {

            let { isDesktop, isMobile, reduceMotion } = context.conditions;

            if(reduceMotion) {

                gsap.set(this.textLines, {
                    opacity: 1,
                    translateY: '0%',
                });

                gsap.set(this.gradientWrapper, {
                    opacity: 1,
                    translateY: '-30%',
                });

                this.elm.classList.add('m-home-hero--finished');

                return;
            }

            // Text lines
            this.textTimeline = gsap.timeline();
            this.textTimeline.to(this.textLines, {
                opacity: 1,
                ease: 'power3.inOut',
                duration: 1.5,
                stagger: 0.1,
                delay: 1.5
            });
            this.textTimeline.to(this.textLines, {
                translateY: '0%',
                ease: 'power3.inOut',
                duration: 2,
                stagger: 0.1,
                delay: 1.2
            }, 0);

            // Green
            this.gradientTimeline = gsap.timeline();
            this.gradientTimeline.to(this.gradientWrapper, {
                translateY: '60%',
                opacity: 1,
                ease: 'sine.out',
                duration: 1,
                delay: 0
            });
            this.gradientTimeline.to(this.gradientWrapper, {
                translateY: '-15%',
                ease: 'power1.inOut',
                duration: 2,
                onStart: () => {
                    this.elm.classList.add('m-home-hero--almost-visible');
                },
                onComplete: () => {
                    this.elm.classList.add('m-home-hero--visible');

                    setTimeout(() => {
                        this.elm.classList.add('m-home-hero--finished');
                    }, 1000);
                }
            }, 1);

        });

	}

    destroy() {
        window.removeEventListener('mousemove', this.boundHandleMousemove);
        this.removeTicker();
    }

}
